import React from "react";

// Small shared icon set — one <path> set per key, all stroke-based so they
// inherit currentColor. Keeps every mega-menu item / feature card / module
// card visually consistent without repeating inline SVG everywhere.
const PATHS = {
  product: "M4 7.5 12 3l8 4.5v9L12 21l-8-4.5v-9Z M4 7.5 12 12l8-4.5 M12 12v9",
  modules: "M4 4h7v7H4V4Zm9 0h7v7h-7V4ZM4 13h7v7H4v-7Zm9 0h7v7h-7v-7Z",
  attendance: "M12 8.4a3.4 3.4 0 1 0 0 6.8 3.4 3.4 0 0 0 0-6.8Z M5 19c1.2-3.4 4-5 7-5s5.8 1.6 7 5",
  leave: "M4 12h9m0 0-3.5-3.5M13 12l-3.5 3.5M15 5.5h5v13h-5",
  payroll: "M6 4h9l3 3v13H6V4Z M15 4v3h3 M9 12h6 M9 15.5h6",
  branch: "M4 20V9l8-5 8 5v11 M9 20v-6h6v6",
  dashboard: "M4 5h16v10H4z M9 20h6 M12 15v5",
  features: "M12 2.5 14.8 8l6 .9-4.4 4.2 1 6L12 16l-5.4 3 1-6L3.2 8.9l6-.9L12 2.5Z",
  workflow: "M4 12h4m0 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm4 0h4m4 0h-4m0 0a2 2 0 1 1-4 0",
  benefits: "M2.5 6.7 4.9 9.1l5-5.2 M4 15v4h16v-4 M4 11h16",
  impact: "M12 21s7-6.1 7-11.4A7 7 0 0 0 5 9.6C5 14.9 12 21 12 21Zm0-8.6a2.8 2.8 0 1 0 0-5.6 2.8 2.8 0 0 0 0 5.6Z",
  docs: "M6 3h8l4 4v14H6V3Z M14 3v4h4 M9 12h6 M9 16h6",
  security: "M12 3 5 6v6c0 4.5 3 7.7 7 9 4-1.3 7-4.5 7-9V6l-7-3Z",
  testing: "M9 3h6 M12 3v6l5 9a2 2 0 0 1-1.7 3H8.7A2 2 0 0 1 7 18l5-9",
  deployment: "M12 3v12m0 0-4-4m4 4 4-4 M5 19h14",
  troubleshooting: "M12 8v5m0 3.5h.01 M10.3 4.6 2.9 17.4A1.5 1.5 0 0 0 4.2 19.6h15.6a1.5 1.5 0 0 0 1.3-2.2L13.7 4.6a1.5 1.5 0 0 0-2.6 0Z",
  selfie: "M12 8.4a3.4 3.4 0 1 0 0 6.8 3.4 3.4 0 0 0 0-6.8Z M5 19c1.2-3.4 4-5 7-5s5.8 1.6 7 5",
  gps: "M12 21s7-6.1 7-11.4A7 7 0 0 0 5 9.6C5 14.9 12 21 12 21Zm0-8.6a2.8 2.8 0 1 0 0-5.6 2.8 2.8 0 0 0 0 5.6Z",
  ticket: "M4 8.4 12 4l8 4.4v7.2L12 20l-8-4.4V8.4Z M12 4v16",
  convert: "M4 12h9m0 0-3.5-3.5M13 12l-3.5 3.5M15 5.5h5v13h-5",
  clock: "M12 7v5l3.2 2 M20 12a8 8 0 1 1-3-6.2",
  check: "m2.5 6.7 2.4 2.4 5-5.2",
  arrow: "M4 10h12M11 5.5 16 10l-5 4.5",
  chevron: "m5 7.5 5 5 5-5",
  close: "m5 5 14 14M19 5 5 19",
  menu: "M3 6h18M3 12h18M3 18h18",
  demo: "M4 6h16v10H8l-4 4V6Z",
};

function Icon({ name, size = 20, className = "" }) {
  const d = PATHS[name] || PATHS.product;
  return (
    <svg
      className={`icon icon-${name} ${className}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path d={d} stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default Icon;
